// extracted by mini-css-extract-plugin
module.exports = {"carouselSlider":"styles-module--carouselSlider--2Hv0x","carouselSliderIcons":"styles-module--carouselSliderIcons--228Ca"};